import type { Locale } from '../auth';

export const STORAGE_KEYS = {
  REFRESH_TOKEN: { key: 'zyn_refresh_token', type: '' },
  REFRESH_TOKEN_EXPIRY: { key: 'zyn_refresh_token_expiry', type: 0 },
  FEATURE_TOGGLES: {
    key: 'zyn_feature_toggles',
    type: {} as Record<string, boolean>,
  },
  CALENDAR_HOUR_LENGTH: { key: 'zyn_calendar_hour_length', type: 0 },
  ADMIN_TOKEN: { key: 'zyn_admin_token', type: '' },
  USER_LOCALE: { key: 'zyn_user_locale', type: '' as Locale },
  CALENDAR_VIEW_MODE: {
    key: 'zyn_calendar_view_mode',
    type: '' as 'daily' | 'weekly' | 'monthly',
  },
  THEME_PREFERENCE: {
    key: 'zyn_theme_preference',
    type: '' as 'light' | 'dark',
  },
  ONBOARDING_TOUR: {
    key: 'zyn_onboarding_tour',
    type: false,
  },
  SETTINGS_HUB_TOUR: {
    key: 'zyn_settings_hub_tour',
    type: false,
  },
  PUSH_OPTED_IN: {
    key: 'zyn_push_opted_in',
    type: false,
  },
  DEVICE_ID: {
    key: 'zyn_device_id',
    type: '',
  },
};

export type StorageKey = keyof typeof STORAGE_KEYS;

export type StorageKeyType<T extends StorageKey> =
  (typeof STORAGE_KEYS)[T]['type'];
